import { isDevelopment } from '@/utils/environment'

export const buildApiBaseURL = (hostName) => {
  // TO DO: Finalizar mock antes desta implementação.
  // if (process.env?.NODE_ENV === 'development') {
  //   return `http://${process.env.VUE_APP_BASE_DOMAIN_URL}`
  // }
  if (process.env.VUE_APP_NGROK_URL_TO_HTTPS) {
    return process.env.VUE_APP_NGROK_URL_TO_HTTPS
  }
  const protocol = isDevelopment() ? 'http' : 'https'
  const subDomainStore = hostName.split('.')[0]
  const domain = process.env.VUE_APP_BASE_DOMAIN_URL
  const baseURL = `${protocol}://${subDomainStore}.${domain}`

  return baseURL
}

export const getBaseURL = () => {
  return buildApiBaseURL(window.location.hostname)
}
